export default [
    {
        path: '/clients',
        name: 'clients',
        component: () => import('../views/Clients.vue'),
        meta: {
            requiresAuth: true,
            authorize: ['ROLE_ADMIN'],
            layout: 'default',
            breadcrumb: 'clients',
            description: 'Gestion des clients'
        }
    }
]
